import { Billboard } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import * as THREE from 'three';

export function MinimalHotspot({
  position,
  active,
  hovered,
  colorDefault = '#9aa4ad',
  colorHover = '#58b0ff',
  colorActive = '#ffb84d',
  onPointerEnter,
  onPointerLeave,
  onClick,
}: {
  position: THREE.Vector3;
  active: boolean;
  hovered: boolean;
  colorDefault?: string;
  colorHover?: string;
  colorActive?: string;
  onPointerEnter?: () => void;
  onPointerLeave?: () => void;
  onClick?: (e: any) => void;
}) {
  const group = useRef<THREE.Group>(null!);
  useFrame((_, dt) => {
    const target = hovered ? 1.1 : active ? 1.06 : 1;
    const s = group.current.scale.x;
    const ns = THREE.MathUtils.damp(s, target, 6, dt);
    group.current.scale.setScalar(ns);
  });

  const color = hovered ? colorHover : active ? colorActive : colorDefault;

  return (
    <group ref={group} position={position}>
      <Billboard follow>
        {/* dot */}
        <mesh onPointerEnter={onPointerEnter} onPointerLeave={onPointerLeave} onClick={onClick}>
          <circleGeometry args={[0.12, 32]} />
          <meshBasicMaterial color={color} />
        </mesh>

        {/* ring */}
        <mesh>
          <ringGeometry args={[0.17, 0.19, 48]} />
          <meshBasicMaterial color={color} transparent opacity={0.9} />
        </mesh>
      </Billboard>
    </group>
  );
}
